/** @deprecated Используйте @/modules/common/enums/end-point */
export const DOC_COMMENTS_GET = 'docs/comments/get/';
export const DOCS_VIEWS_ALL = 'docs/views/all/get/';
export const DOC_LINKS_GET = 'doc/links/get/';
export const DOC_FILES_GET = 'doc/files/get/';
export const DOC_SIGNATURES_FILES_GET = 'docs/files/signs/get/';
export const DOCS_CLIENTS_GET = 'docs/clients/get/';
export const CLIENTS_ADDRESSES_GET = 'clients/address/get/';
export const CLIENTS_COMMENTS_GET = 'clients/comments/get/';
export const CLIENTS_CONTACTS_GET = 'clients/contacts/get/';
export const CLIENTS_DOCS_GET = 'clients/docs/get/';
export const DOC_GANTT_ITEMS = 'docs/gantt/items/get/';
export const AUTO_REPLACES_GET = 'autoreplacewords/get/';
export const SYSTEM_FILE_GET = 'system/file/get/';
export const SYSTEM_FILE_SIGN_MULTIPLE = 'system/file/sign/multiple/';
